import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import ContentCatalogue from '../ContentCatalogue';
import ContentManagementPanel from '../ContentManagementPanel/ContentManagementPanel';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './CatalogueLayout.css';

interface ContentContextType {
    selectedProjectId: string | undefined;
    onProjectSelect: (id: string | undefined) => void;
}

const CatalogueLayout: React.FC = () => {
    const { selectedProjectId } = useOutletContext<ContentContextType>();
    const [panelOpen, setPanelOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleDataChange = () => {
        setRefreshKey(k => k + 1);
    };

    return (
        <div className="catalogue-layout">
            {/* Main catalogue area */}
            <div className="catalogue-main">
                <ContentCatalogue
                    projectId={selectedProjectId || null}
                    fullpage
                    refreshKey={refreshKey}
                />
            </div>

            {/* Right management panel */}
            <div className={`catalogue-management-panel ${panelOpen ? '' : 'collapsed'}`}>
                <ContentManagementPanel
                    projectId={selectedProjectId}
                    onDataChange={handleDataChange}
                />
            </div>

            {/* Panel toggle button */}
            <button
                className={`catalogue-panel-toggle-btn ${panelOpen ? 'panel-open' : 'panel-collapsed'}`}
                onClick={() => setPanelOpen(!panelOpen)}
                title={panelOpen ? 'Hide panel' : 'Show panel'}
            >
                {panelOpen ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
            </button>
        </div>
    );
};

export default CatalogueLayout;
